export default __webpack_public_path__ + "static/media/othello.13fcddf1.png";